import { JobMatchStageEnum } from '@libs/graphql-types';

export const JOB_MATCH_STAGE_LABELS: Record<JobMatchStageEnum, string> = {
  [JobMatchStageEnum.InstantMatch]: 'Instant Match',
  [JobMatchStageEnum.Application]: 'Application',
  [JobMatchStageEnum.InternalInterview]: 'Internal Interview',
  [JobMatchStageEnum.Submittal]: 'Submittal',
  [JobMatchStageEnum.ShortList]: 'Shortlist',
  [JobMatchStageEnum.ClientInterview]: 'Client Interview',
  [JobMatchStageEnum.Offer]: 'Offer',
  [JobMatchStageEnum.Onboarding]: 'Onboarding',
  [JobMatchStageEnum.Rejected]: 'Rejected',
  [JobMatchStageEnum.Placement]: 'Placement',
};
